import { useQuery } from '@tanstack/react-query';

import { currentAccountService } from '../services/currentAccount.service';

export const useCurrentAccountTaxpayerStats = (taxpayerId: string) => {
  return useQuery({
    queryKey: ['current-account-stats', taxpayerId],
    queryFn: () => currentAccountService.getTaxpayerStats(taxpayerId)
  });
};
